import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ChartOfAccountsTemplateRow } from "../chartOfAccountsTemplatesViewConfig";

export const ChartOfAccountsTemplateNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ChartOfAccountsTemplateRow, string>) => (
        <ViewTableCell>
            <span>{row.original.name}</span>
        </ViewTableCell>
    ),
);
